import { useEffect, useRef } from 'react';
import { Html5QrcodeScanner, Html5QrcodeSupportedFormats } from 'html5-qrcode';
import { Button } from './ui/button';
import { X } from 'lucide-react';

export default function BarcodeScanner({ onScan, onClose }) {
  const scannerRef = useRef(null);

  useEffect(() => {
    // Unique ID for the scanner element to avoid conflicts if multiple
    const elementId = "reader";
    
    // Scanner configuration
    const config = {
      fps: 10,
      qrbox: { width: 250, height: 250 },
      aspectRatio: 1.0,
      rememberLastUsedCamera: true
    };

    // Initialize scanner
    // Note: Html5QrcodeScanner creates its own UI.
    const scanner = new Html5QrcodeScanner(elementId, config, /* verbose= */ false);
    
    scanner.render(
      (decodedText, decodedResult) => {
        // Success callback
        if (onScan) {
          onScan(decodedText);
          // Optional: clear scanner on success? Or keep scanning?
          // Usually scan one item -> close or beep. Let parent handle close.
        }
      },
      (errorMessage) => {
        // Error callback (scanning failure)
        // console.log(errorMessage);
      }
    );

    scannerRef.current = scanner;

    // Cleanup function
    return () => {
      if (scannerRef.current) {
        scannerRef.current.clear().catch(error => {
            console.error("Failed to clear html5-qrcode scanner. ", error);
        });
      }
    };
  }, [onScan]);

  return (
    <div className="relative bg-background p-4 rounded-lg shadow-lg border w-full max-w-sm mx-auto">
        <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-semibold">Escanear Código</h3>
            <Button variant="ghost" size="icon" onClick={onClose}>
                <X className="h-4 w-4" />
            </Button>
        </div>
        <div id="reader" className="w-full"></div>
        <p className="text-xs text-muted-foreground mt-2 text-center">
            Apunta la cámara al código de barras del producto.
        </p>
    </div>
  );
}
